import { render, staticRenderFns } from "./NewProducts.vue?vue&type=template&id=5630f412&scoped=true&"
import script from "./NewProducts.vue?vue&type=script&lang=js&"
export * from "./NewProducts.vue?vue&type=script&lang=js&"
import style0 from "./NewProducts.vue?vue&type=style&index=0&id=5630f412&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5630f412",
  null
  
)

export default component.exports